import { Servis } from './Servis';
import { getAktifLisanslar } from './lisans';

// AT-Y: AiYardimciHelper.Katalog()'un FE'ye açılan alt kümesi (Kod/Baslik/ModulLisansKod/CiktiTipi).
// lisans.js'teki getAktifLisanslar() ile AYNI cache deseni: sayfa yüklemesinde tek istek,
// AiYardimciButonu her mount noktasında bunu tekrar çağırsa da tek ağ isteği paylaşılır.
let _katalogPromise = null;

export function getAiYardimciKatalog() {
  if (_katalogPromise) return _katalogPromise;
  _katalogPromise = (async () => {
    try {
      const res = await Servis('GET', 'GetAiYardimciKatalog', '');
      return (res.status === 200 && Array.isArray(res.data)) ? res.data : [];
    } catch {
      return [];
    }
  })();
  return _katalogPromise;
}

// AY-1: AiAlanYardimci (✨ metin menüsü) görünürlüğü — yalnız aipanel lisansı + BE'de metin_* kodları.
// Sonuç cache'lenmez (lisans cache'i login'de sıfırlanıyor); iki alt promise zaten cache'li, ek istek yok.
export async function aiAlanYardimciAktif() {
  try {
    const [set, kat] = await Promise.all([getAktifLisanslar(), getAiYardimciKatalog()]);
    return !!set && set.has('aipanel') && kat.some((k) => k.Kod === 'metin_yaz');
  } catch {
    return false;
  }
}
